import React from 'react'
import Setup from '../components/Tab/Setup'

const IndentityandmealSetup = () => {
  return (
    <>
      <Setup />
    </>
  )
}

export default IndentityandmealSetup
